var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5971 6.77251L6.72206 1.89751C6.52706 1.70251 6.25623 1.58334 5.95831 1.58334L2.16665 1.58334C1.57081 1.58334 1.08331 2.07084 1.08331 2.66668L1.08331 6.45834C1.08331 6.75626 1.20248 7.02709 1.4029 7.22751L6.2779 12.1025C6.4729 12.2975 6.74373 12.4167 7.04165 12.4167C7.33956 12.4167 7.6104 12.2975 7.8054 12.0971L11.5971 8.30543C11.7975 8.11043 11.9166 7.83959 11.9166 7.54168C11.9166 7.24376 11.7921 6.96751 11.5971 6.77251ZM7.04165 11.3388L2.16665 6.45834L2.16665 2.66668L5.95831 2.66668V2.66126L10.8333 7.53626L7.04165 11.3388Z",
    fill: "#673C8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52081 4.83334C3.96954 4.83334 4.33331 4.46957 4.33331 4.02084C4.33331 3.57211 3.96954 3.20834 3.52081 3.20834C3.07208 3.20834 2.70831 3.57211 2.70831 4.02084C2.70831 4.46957 3.07208 4.83334 3.52081 4.83334Z",
    fill: "#673C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.bf3346a228f450bf12bce735165cb0ef.svg";
export { ForwardRef as ReactComponent };